export default "__VITE_ASSET__2_$DFy3g__"